import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AccountSetupComponent } from './account-setup.component';


@NgModule({
  imports: [
    RouterModule.forRoot([
    {
        path: 'manage-billing',
        component: AccountSetupComponent,
    },
])
  ],
  exports: [RouterModule]
})
export class AccountSetupRoutingModule { }
